import { RefObject, useEffect } from "react";

/**
 * Close a popover/dropdown when the user clicks outside its container.
 *
 * Listener is attached only while `enabled` is true so closed dropdowns don't
 * pay for a document-level mousedown handler.
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  enabled: boolean,
  onOutside: () => void,
): void {
  useEffect(() => {
    if (!enabled) return;
    const handler = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onOutside();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref, enabled, onOutside]);
}
